import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import AppLayout from "./AppLayout";

import RegisterPage from "./pages/RegisterPage";
import Home from "./pages/Home";
import Stream from "./pages/Stream";
import NotFound from "./pages/NotFound";
import LoginPage from "./pages/LoginPage";
import ProfilePage from "./pages/ProfilePage";
import View from "./pages/View";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import MakePaymentPage from "./pages/MakePaymentPage";

import AuthBootstrapper from "./components/AuthBootstrapper";
import PaymentStatusPage from "./pages/PaymentStatusPage";
import VerifyEmail from "./pages/VerifyEmail";


const App = () => {

  return (
    
    <Router>
    <AppLayout>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/view" element={<View />} />
        <Route path="/broadcast" element={<Stream />} />

        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
        <Route path="/profile" element={<ProfilePage />} />

        <Route path="/payment" element={<MakePaymentPage />} />
        <Route path="/payment-status" element={<PaymentStatusPage />} />
        
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppLayout>
  </Router>
  )
}
export default App;
